import React from 'react';
import { Content } from '../components';
import { Button, UploadInput } from '../components/Modal';
import classes from '../styles/ClinicDocuments.module.css';

interface iDocType {
  value: string;
  file?: File;
  error: string;
}
interface iDoc {
  hipaa: iDocType;
  insurance: iDocType;
  contactCare: iDocType;
}

const ClinicDocuments = () => {
  const [documents, setDocuments] = React.useState<iDoc>({
    hipaa: { value: '', error: '' },
    insurance: { value: '', error: '' },
    contactCare: { value: '', error: '' },
  });

  const uploadHipaaDocument = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!documents.hipaa.value || !documents.hipaa.file) {
      setDocuments(prevVal => ({ ...prevVal, hipaa: { ...prevVal.hipaa, error: 'Please choose PDF file' } }));
    } else {
      alert('call upload api');
    }
  };
  const uploadInsuranceDocument = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!documents.insurance.value || !documents.insurance.file) {
      setDocuments(prevVal => ({ ...prevVal, insurance: { ...prevVal.insurance, error: 'Please choose PDF file' } }));
    } else {
      alert('call upload api');
    }
  };
  const uploadContactCareDocument = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!documents.contactCare.value || !documents.contactCare.file) {
      setDocuments(prevVal => ({ ...prevVal, contactCare: { ...prevVal.contactCare, error: 'Please choose PDF file' } }));
    } else {
      alert('call upload api');
    }
  };

  return (
    <Content currentMenu='documents' headerTitle='Documents' addBtn={false} searchBox={false}>
      <div className={classes.container}>
        <form className={classes.form_container} onSubmit={uploadHipaaDocument}>
          <h3 className={classes.heading}>HIPAA Compliance Document</h3>
          <p className={classes.subheading}>Upload document</p>
          <UploadInput
            label='Choose PDF document'
            accept='application/pdf'
            onChange={e => {
              if (e.target.files && e.target.files[0] && !e.target.files[0].type.startsWith('application/pdf')) {
                setDocuments(prevVal => ({ ...prevVal, hipaa: { value: '', error: 'Please choose PDF file' } }));
              } else {
                setDocuments(prevVal => ({
                  ...prevVal,
                  hipaa: {
                    value: e.target.files ? e.target.files[0]?.name : '',
                    file: e.target.files ? e.target.files[0] : undefined,
                    error: '',
                  },
                }));
              }
            }}
            errorMessage={documents.hipaa.error}
            style={{ backgroundColor: 'transparent', boxShadow: 'none', padding: '0' }}
          />
          <Button label='Upload' span={false} type='submit' submitButtonStyle={{ padding: '.5rem 2rem', marginTop: '1rem' }} />
        </form>

        <form className={classes.form_container} onSubmit={uploadInsuranceDocument}>
          <h3 className={classes.heading}>Insurance Forms Document</h3>
          <p className={classes.subheading}>Upload document</p>
          <UploadInput
            label='Choose PDF document'
            accept='application/pdf'
            onChange={e => {
              if (e.target.files && e.target.files[0] && !e.target.files[0].type.startsWith('application/pdf')) {
                setDocuments(prevVal => ({ ...prevVal, insurance: { value: '', error: 'Please choose PDF file' } }));
              } else {
                setDocuments(prevVal => ({
                  ...prevVal,
                  insurance: {
                    value: e.target.files ? e.target.files[0]?.name : '',
                    file: e.target.files ? e.target.files[0] : undefined,
                    error: '',
                  },
                }));
              }
            }}
            errorMessage={documents.insurance.error}
            style={{ backgroundColor: 'transparent', boxShadow: 'none', padding: '0' }}
          />
          <Button label='Upload' span={false} type='submit' submitButtonStyle={{ padding: '.5rem 2rem', marginTop: '1rem' }} />
        </form>

        <form className={classes.form_container} onSubmit={uploadContactCareDocument}>
          <h3 className={classes.heading}>Contact of Care Document</h3>
          <div className={classes.iframe_container}>
            <iframe src='./assets/sample.pdf' title='Contact of Care Document' />
            <div>
              <p>Uploaded Contact of Care Document</p>
              <button>View PDF in large size</button>
            </div>
          </div>
          <p className={classes.subheading}>Want to change uploaded Contact of Care Document?</p>
          <UploadInput
            label='Choose PDF document'
            accept='application/pdf'
            onChange={e => {
              if (e.target.files && e.target.files[0] && !e.target.files[0].type.startsWith('application/pdf')) {
                setDocuments(prevVal => ({ ...prevVal, contactCare: { value: '', error: 'Please choose PDF file' } }));
              } else {
                setDocuments(prevVal => ({
                  ...prevVal,
                  contactCare: {
                    value: e.target.files ? e.target.files[0]?.name : '',
                    file: e.target.files ? e.target.files[0] : undefined,
                    error: '',
                  },
                }));
              }
            }}
            errorMessage={documents.contactCare.error}
            style={{ backgroundColor: 'transparent', boxShadow: 'none', padding: '0' }}
          />
          <Button label='Change' span={false} type='submit' submitButtonStyle={{ padding: '.5rem 2rem', marginTop: '1rem' }} />
        </form>
      </div>
    </Content>
  );
};

export default ClinicDocuments;
